const isDefined = require('../is-defined')
/**
 * Set a cookie
 * @param {string} name - Cookie name
 * @param {*} value - Cookie value
 * @param {Date} expirationDate - Expiration date
 * @returns {boolean} Returns true if successful or false if unsuccessful
 */
const setCookie = (name, value, expirationDate) => {
  try {
    if (typeof expirationDate === 'string') {
      expirationDate = new Date(expirationDate)
    }

    if (Object.prototype.toString.call(expirationDate) === '[object Date]') {
      expirationDate = expirationDate.toUTCString()
    }

    document.cookie = `${name}=${value}${
      isDefined(expirationDate) ? `;expires=${expirationDate}` : ''
    }`

    return true
  } catch (err) {
    return false
  }
}

module.exports = setCookie
